import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '../index'

export const selectProjectsState = (state: RootState) => state.projects
export const selectProjectsById = (state: RootState) => state.projects.byId
export const selectProjectsAllIds = (state: RootState) => state.projects.allIds
export const selectProjectsLoading = (state: RootState) => state.projects.loading
export const selectProjectsError = (state: RootState) => state.projects.error
export const selectMemberProjectIds = (state: RootState) => state.projects.memberProjectIds

export const selectAllProjects = createSelector(
    [selectProjectsById, selectProjectsAllIds],
    (byId, allIds) => allIds.map((id: string) => byId[id]).filter(Boolean)
)

export const selectProjectById = (state: RootState, projectId: string) =>
    state.projects.byId[projectId]

export const selectProjectMemberIds = (state: RootState, projectId: string): Set<string> => {
    const project = state.projects.byId[projectId]
    if (!project) return new Set()
    return new Set([project.ownerId, ...(project.members || [])])
}

export const selectProjectInvite = (state: RootState) => state.projects.invite
